<div id="buyer-home-body" class="buyer-home-body" [class.mobile]="topService.isMobile" *ngIf="!isMaintenanceMode">
  <div class="buyer-home-main">
    <router-outlet></router-outlet>
  </div>
</div>

<app-mobile-notifications-modal *ngIf="showPhonePopup()" (closeModal)="closePhonePopup()"></app-mobile-notifications-modal>

<app-bottom-nav-mobile *ngIf="topService.isMobile && !isMaintenanceMode"></app-bottom-nav-mobile>
